<script lang="ts" setup>
import { ref, watch, toRefs } from 'vue';
import { Weekday, WeekdayStr } from 'rrule';
import { EMIT, RRULE_WEEKDAY } from '@/enum';
import ToggleButton from 'primevue/togglebutton';
interface Props {
  selectedValues: number[];
}

const emit = defineEmits<{
  (e: EMIT.UPDATE, values: number[]): void;
}>();

const props = defineProps<Props>();

const { selectedValues } = toRefs(props);
const selectedRecurringWeekdays = ref<number[]>(selectedValues.value);
const recurringWeekdays = ref<{ label: string; value: boolean }[]>(
  [...Object.keys(RRULE_WEEKDAY)]
    // we only need the keys that are day strings
    .filter((value) => isNaN(Number(value)))
    .map((value, i) => {
      // if they are editting an event that has a custom recurrence
      // we need to auto select the weekdays they previously had
      const toggled = Array.isArray(selectedRecurringWeekdays.value)
        ? selectedRecurringWeekdays.value.includes(i)
        : false;
      return { label: value, value: toggled };
    }),
);

watch(
  () => recurringWeekdays,
  (weekdays) => {
    selectedRecurringWeekdays.value = [];

    weekdays.value.forEach((day) => {
      if (day.value) {
        const rRuleDay: WeekdayStr = day.label.toUpperCase() as WeekdayStr;
        selectedRecurringWeekdays.value.push(Weekday.fromStr(rRuleDay).weekday);
      }
    });

    emit(EMIT.UPDATE, selectedRecurringWeekdays.value);
  },
  { deep: true },
);
</script>

<template>
  <div class="field col required py-0 px-2">
    <label for="weekday_buttons">Repeat on</label>
    <div class="field-checkbox flex flex-row justify-content-between my-1">
      <ToggleButton
        v-for="weekday of recurringWeekdays"
        :key="weekday.label"
        v-model="weekday.value"
        :on-label="weekday.label"
        :off-label="weekday.label"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.p-togglebutton {
  height: 24px;
  width: 24px;
  display: flex;
  padding: 0;
  border-radius: 25px;
  border: none;
  &.p-highlight,
  &.p-highlight:hover {
    background: var(--primary-color-light);
    border-color: var(--primary-color-light);
    color: var(--primary-color-dark);
  }
  :deep(.p-button) {
    width: 100%;
    height: 100%;
    padding: 0;
    border-radius: 25px;
    .p-button-label {
      font-weight: 300;
      font-size: 10px;
    }
  }
}
</style>
